// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.ui-controls[data-v-10683f20] {
  position: relative;
  width: 100%;
}
.controls-group[data-v-10683f20] {
  display: flex;
  flex-wrap: wrap;
}
.controls-group > *[data-v-10683f20] {
  margin-top: 1rem;
}
.active-controls > *[data-v-10683f20] {
  margin-left: auto;
  margin-right: auto;
}
.active-controls.controls-hidden[data-v-10683f20],
.main-controls.controls-hidden[data-v-10683f20] {
  pointer-events: none;
  display: none;
}
.mobile-app .ui-button[data-v-10683f20] {
  width: 100%;
}
.mobile-app .controls-group[data-v-10683f20] {
  flex-direction: column-reverse;
}
@media screen and (max-width: 30em) {
.desktop-app .controls-group[data-v-10683f20] {
    flex-direction: column-reverse;
}
.desktop-app .ui-button[data-v-10683f20] {
    width: 100%;
}
}
`, "",{"version":3,"sources":["webpack://./src/components/ui/UiControlsFrame.vue"],"names":[],"mappings":";AAkDA;EACA,kBAAA;EACA,WAAA;AACA;AAEA;EACA,aAAA;EACA,eAAA;AACA;AAEA;EACA,gBAAA;AACA;AAEA;EACA,iBAAA;EACA,kBAAA;AACA;AAEA;;EAEA,oBAAA;EACA,aAAA;AACA;AAEA;EACA,WAAA;AACA;AAEA;EACA,8BAAA;AACA;AAEA;AACA;IACA,8BAAA;AACA;AAEA;IACA,WAAA;AACA;AACA","sourcesContent":["<template>\n  <div v-show=\"hideControls\" class=\"ui-controls\">\n    <div\n      v-if=\"hasActiveControls\"\n      class=\"controls-group active-controls\"\n      :class=\"{ 'controls-hidden': !activeControls }\"\n    >\n      <slot name=\"active\" />\n    </div>\n    <div\n      v-if=\"hasMainControls\"\n      class=\"controls-group main-controls\"\n      :class=\"{ 'controls-hidden': activeControls }\"\n    >\n      <slot name=\"main\" />\n    </div>\n  </div>\n</template>\n\n<script>\nimport getters from '@src/store/getters'\nimport { mapGetters } from 'vuex'\n\nexport default {\n  name: 'ui-controls-frame',\n\n  computed: {\n    ...mapGetters([getters.isCameraActive, getters.isCameraLoading]),\n\n    hasMainControls() {\n      return !!this.$slots.main\n    },\n\n    hasActiveControls() {\n      return !!this.$slots.active\n    },\n\n    activeControls() {\n      const { hasActiveControls, isCameraActive } = this\n      return hasActiveControls && isCameraActive\n    },\n\n    hideControls() {\n      return !this.isCameraLoading\n    }\n  }\n}\n</script>\n\n<style scoped>\n.ui-controls {\n  position: relative;\n  width: 100%;\n}\n\n.controls-group {\n  display: flex;\n  flex-wrap: wrap;\n}\n\n.controls-group > * {\n  margin-top: 1rem;\n}\n\n.active-controls > * {\n  margin-left: auto;\n  margin-right: auto;\n}\n\n.active-controls.controls-hidden,\n.main-controls.controls-hidden {\n  pointer-events: none;\n  display: none;\n}\n\n.mobile-app .ui-button {\n  width: 100%;\n}\n\n.mobile-app .controls-group {\n  flex-direction: column-reverse;\n}\n\n@media screen and (max-width: 30em) {\n  .desktop-app .controls-group {\n    flex-direction: column-reverse;\n  }\n\n  .desktop-app .ui-button {\n    width: 100%;\n  }\n}\n</style>\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
